import React from 'react'

interface Props {
	leftContent: React.ReactNode;
    rightContent:React.ReactNode;
}

const Card2:React.FC<Props> = ({leftContent,rightContent}) =>{
  return (
    <div className='w-full flex items-center justify-center h-full'>
        <div className='flex bg-white sm:p-4 sm:shadow-xl sm:rounded-xl h-full w-full'>
            <div className='hidden w-[50%] md:block h-full'>{leftContent}</div>
            <div className='w-full h-full overflow-y-auto md:w-[50%]'>{rightContent}</div>
        </div>
    </div>
  )
}

export default Card2
